import { clsx } from "clsx";
import moment from "moment";
import momentJalaali from "moment-jalaali";
import PN from "persian-number";
import { toast } from "react-toastify";
import { twMerge } from "tailwind-merge";

const persianMonths = [
  "فروردین",
  "اردیبهشت",
  "خرداد",
  "تیر",
  "مرداد",
  "شهریور",
  "مهر",
  "آبان",
  "آذر",
  "دی",
  "بهمن",
  "اسفند",
];

export function getImage(src) {
  if (!src) return false;

  if (src.startsWith("https")) {
    return src;
  }

  return import.meta.env.VITE_STORAGE_ENDPOINT + src;
}
export function PeToEn(num) {
  return PN.convertPeToEn(num);
}

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}
export function unixCoverter(unix) {
  const momentObj = moment.unix(unix);

  const year = momentObj.format("YYYY");
  const month = momentObj.format("MM");
  const day = momentObj.format("DD");
  return `${year}-${month}-${day}`;
}

export function persianMomentConverter(date) {
  // Ensure the input is a Date object or convert it if needed
  const unixTimestamp = Math.floor(date.getTime() / 1000); // Convert to Unix in seconds
  const momentObj = moment.unix(unixTimestamp).utcOffset("+0330"); // Set the timezone offset if needed

  // Format as "YYYY-MM-DD"
  const formattedDate = momentObj.format("YYYY-MM-DD");
  //console.log({formattedDate})

  return formattedDate;
}

export function unixToPersianDay(unix) {
  if (!unix) {
    return "-";
  }
  const momentObj = momentJalaali.unix(unix);

  const day = momentObj.format("jDD");
  const monthIndex = momentObj.format("jM") - 1;
  const year = momentObj.format("jYYYY");

  const formattedDate = `${day} ${persianMonths[monthIndex]} ${year}`;

  return formattedDate;
}
export function unixToPersianTime(unix) {
  if (!unix) {
    return "-";
  }
  const momentObj = momentJalaali.unix(unix);

  const time = momentObj.format("HH:mm");

  const formattedTime = `${time}`;

  return formattedTime;
}

export function unixToPersian(unix) {
  if (!unix) {
    return "-";
  }
  const momentObj = momentJalaali.unix(unix).format(`jYYYY-jMM-jDD`);
  return momentObj;
}

export function sanitizeValues(values) {
  const sanitized = {};
  for (const key in values) {
    sanitized[key] = values[key] === null ? "" : values[key];
  }
  return sanitized;
}

export function transformBusinessData(input) {
  const businessDataKey = input.is_real ? "real_business_data" : "legal_business_data";

  // Construct the business data object
  const businessData = {
    fa_name: input.fa_name,
    en_name: input.en_name,
    ...(input.is_real ? {} : { national_id: input.national_id }),
    ...(input.is_real ? {} : { register_code: input.register_code }),
    ...(input.is_real ? {} : { register_date: input.register_date }),
    tax_code: input.tax_code,
    address: input.address,
    phone: input.phone,
    postal_code: input.postal_code,
    ...(input.is_real ? {} : { announcement_image: input.announcement_image?.url }),
    ...(input.is_real ? {} : { last_announcement_image: input.last_announcement_image?.url }),

    category_id: input.category_id,
    subcategory_id: input.subcategory_id,
    logo: input.logo?.url,
    business_license_image: input.business_license_image?.url || "",
  };

  const walletData = {
    account_id: input.account_id,
  };

  return {
    [businessDataKey]: businessData,
    wallet_data: walletData,
  };
}

export const mergedItems = (data) => {
  const { form_transactions, gateway_transactions, pos_transactions } = data;
  return [
    ...form_transactions.items.map((item) => ({ ...item, type: "form" })),
    ...gateway_transactions.items.map((item) => ({ ...item, type: "gateway" })),
    ...pos_transactions.items.map((item) => ({ ...item, type: "pos" })),
  ];
};

export const handleErrorApi = (error) => {
  let errorCode = String(error.response?.status);
  if (error.code === "ERR_NETWORK") {
    toast.error("مشکل در سرویس اینترنت به وجود آمده است، مجدد اقدام کنید. ");
  }
  if (errorCode >= "500" && errorCode <= "599") {
    // Check if the error code is between 500 and 599
    if (error.response.data.detail) {
      toast.error(error.response.data.detail);
    } else {
      toast.error("ارتباط با سرور میسر نشد لظفا مجدد تلاش نمایید");
    }
  } else {
    switch (errorCode) {
      case "400":
        toast.error(error.response.data.detail.message);
        break;
      case "403":
        toast.error(error.response.data.detail.message);
        break;
      case "422":
        for (let index = 0; index < error.response.data.detail.length; index++) {
          toast.error(error.response.data.detail[index].msg);
        }
        break;
      default:
    }
  }
};
export function convertToUnix(dateString) {
  const momentObj = moment(dateString, "YYYY-MM-DD");

  // Convert to Unix timestamp
  const unixTimestamp = momentObj.unix();

  return unixTimestamp;
}

export function fomatCardNumber(cardNumber) {
  if (!cardNumber) {
    return "-";
  }
  return cardNumber.replace(/\*{6}/, "...");
}

export function formatNumberWithCommas(number) {
  if (typeof number !== "number") {
    return ""; // Return an empty string if the input is not a number
  }

  // Convert the number to a string
  let [integerPart, fractionalPart] = number.toString().split(".");

  // Add commas to the integer part using a regular expression
  integerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ",");

  // Return the formatted number with the fractional part (if it exists)
  return fractionalPart ? `${integerPart}.${fractionalPart}` : integerPart;
}

// export function numberWithCommas(x) {
//   //console.log(typeof(x))
//   const y=Nx.toLocaleString().toString()
//   // //console.log({x:Number(x).toLocaleString()})

//   return y
// }

export function convertPersianToEnglishNumber(persianNumberString) {
  // Define the mapping of Persian numerals to English numerals
  const persianToEnglishMap = {
    "۰": "0",
    "۱": "1",
    "۲": "2",
    "۳": "3",
    "۴": "4",
    "۵": "5",
    "۶": "6",
    "۷": "7",
    "۸": "8",
    "۹": "9",
  };

  // Replace Persian numerals with English numerals
  let englishNumberString = persianNumberString.replace(/[۰-۹]/g, (match) => persianToEnglishMap[match]);

  // Remove any commas from the string
  englishNumberString = englishNumberString.replace(/,/g, "");

  return englishNumberString;
}

/////////////////////////////////////////////////
export function toLocaleStringFormatter(x) {
  if (!x) return "-";

  // Ensure x is a string
  x = typeof x !== "string" ? String(x) : x;

  return Number(x).toLocaleString();
}

//////////////////////////////////////////////////////

export function removeLoSt(x) {
  if (!x) return "0";

  // Ensure x is a string
  x = typeof x !== "string" ? String(x) : x;

  return x.replace(/,/g, "");
}

//////////////////////////////////////////////////////

export function amountFormatter(x) {
  if (!x) return "0";

  // Ensure x is a string
  x = typeof x !== "string" ? String(x) : x;

  return Number(x.replace(/,/g, "")).toLocaleString();
}
export function wageCalculator(amountStr, wagePercentage, minWage, maxWage) {
  if (!amountStr || !wagePercentage || !minWage || !maxWage) return "0";

  amountStr = typeof amountStr !== "string" ? String(amountStr) : amountStr;

  const amount = parseFloat(amountStr.replace(/,/g, ""));

  if (isNaN(amount) || amount < 10000) return "0";

  const calculatedWage = (amount * wagePercentage) / 100;

  //console.log({calculatedWage,maxWage})

  //console.log(calculatedWage,)
  if (calculatedWage < minWage) {
    return minWage.toLocaleString();
  } else if (calculatedWage > maxWage) {
    return maxWage.toLocaleString();
  } else {
    return calculatedWage.toLocaleString();
  }
}

export function processFormData(data, business_type, business_id) {
  // Replace empty string values with null
  Object.keys(data).forEach((key) => {
    if (data[key] === "") data[key] = null;
  });

  // Set business ID based on business type
  if (business_type === "real") {
    data.realbusiness_id = business_id;
  } else if (business_type === "legal") {
    data.legalbusiness_id = business_id;
  }

  // Convert expire_time to Unix timestamp if present
  if (data.expire_time) {
    data.expire_time = convertToUnix(data.expire_time);
  }

  // Clean and convert target_amount to a number if present
  if (data.target_amount) {
    const cleanValue = data.target_amount.replace(/,/g, "").trim();
    data.target_amount = Number(cleanValue);
  }

  // Clean and convert form_amount_amount to a number if present
  if (data.form_amount) {
    const cleanValue = data.form_amount.replace(/,/g, "").trim();
    data.form_amount = Number(cleanValue);
  }

  return data;
}

export function convertEnglishDaysToPersian(englishDays) {
  const dayMapping = {
    Saturday: "شنبه",
    Sunday: "یکشنبه",
    Monday: "دوشنبه",
    Tuesday: "سه‌شنبه",
    Wednesday: "چهارشنبه",
    Thursday: "پنج‌شنبه",
    Friday: "جمعه",
  };

  return englishDays.map((day) => dayMapping[day] || "Invalid day");
}

export const convertToPersianDate = (englishDate, format = "jYYYY/jMM/jDD") => {
  // Convert the English date to a Jalali date
  const persianDate = momentJalaali(englishDate, "YYYY-MM-DD").format(format);

  return persianDate;
};

export function transformEmptyStringsToNull(obj) {
  if (typeof obj !== "object" || obj === null) {
    return obj; // Return the value as is if it's not an object
  }

  const result = Array.isArray(obj) ? [] : {};

  for (const key in obj) {
    if (obj.hasOwnProperty(key)) {
      const value = obj[key];

      if (value === "") {
        result[key] = null; // Transform empty string to null
      } else if (typeof value === "object" && value !== null) {
        result[key] = transformEmptyStringsToNull(value); // Recursively process nested objects/arrays
      } else {
        result[key] = value; // Retain other values as isy
      }
    }
  }

  return result;
}

export function convertTrackingCodesToString(response) {
  let transactionListStr = response?.data;

  transactionListStr = transactionListStr.replace(/("vanda_tracking_code":)(\d{18})/g, '$1"$2"');

  const parsedData = JSON.parse(transactionListStr);

  return parsedData;
}
